module.exports = __webpack_public_path__ + "img/anadir-imagen.08151d44.svg";